module.exports = __webpack_public_path__ + "static/media/bringtofront.349608ba.png";